"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContract = void 0;
var react_1 = require("react");
var _shared_1 = require("../shared");
function useContract(abi, address, web3) {
    var gasPrice = (0, _shared_1.useGasPrice)().gasPrice;
    return (0, react_1.useMemo)(function () {
        if (!web3 || !address)
            return undefined;
        return new web3.eth.Contract(abi, address, {
            gasPrice: gasPrice,
        });
    }, [web3, address, gasPrice]);
}
exports.useContract = useContract;
